import { useEffect, useState } from 'react'
import { onQueueQuestion, type QueueQuestion } from '../lib/queue'
import { btnPrimary, btnQuiet } from './ui/Page'

// QueuePrompt asks whether an action that cannot start now goes to the queue
// (lib/queue.ts): one place for every action of the UI.
export function QueuePrompt() {
  const [q, setQ] = useState<QueueQuestion | null>(null)
  useEffect(() => onQueueQuestion(setQ), [])
  if (!q) return null
  const answer = (yes: boolean) => {
    q.answer(yes)
    setQ(null)
  }
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" onClick={() => answer(false)}>
      <div className="w-full max-w-lg rounded-lg bg-background p-5 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-semibold">It cannot start now</h3>
        <p className="mt-2 rounded bg-[#EEF0FB] p-2 text-sm text-[#2A367F]">
          {q.reason.charAt(0).toUpperCase() + q.reason.slice(1)}. Add it to the queue: it starts by itself when that is done - if that one fails, this one does not start.
        </p>
        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <button className={btnQuiet} onClick={() => answer(false)}>Cancel</button>
          <button className={btnPrimary} onClick={() => answer(true)}>Add to queue</button>
        </div>
      </div>
    </div>
  )
}
